import React from 'react';
import { useDispatch } from 'react-redux';

import DateRangePickerComponent from '@components/filterComponents/DateRangePickerComponent';

import { objForBuyerEtdDateRange } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const BuyerEtd = () => {
	const dispatch = useDispatch();

	const onChangeDateRange = async (name, type, paramName1, paramName2, value1, value2) => {
		let dateRange = {
			name: 'buyerETD',
			type: 'dateRange',
			key: value1 + ',' + value2,
			value: value1 + ' - ' + value2,
			identifier: 'buyerETDFilterDateRange'
		};
		dispatch(storeItemInGlobalFilter(dateRange));
	};

	return <DateRangePickerComponent item={{ ...objForBuyerEtdDateRange }} onChange={onChangeDateRange} />;
};

export default BuyerEtd;
